import styles from './GetStartedSection.module.scss';
import { Typography } from '@/src/shared/components/Typography';
import { Section } from '@/src/containers/Landings/Section';
import { CtaButton } from '../CtaButton';
import { useIsMobile } from '@/src/shared/hooks/utils/useIsMobile';
import { useInView } from 'react-intersection-observer';
import clsx from 'clsx';
import SimpleVideoPlayer from '@/src/shared/components/SimpleVideoPlayer';

export function GetStartedSection() {
  const isMobile = useIsMobile();
  const { ref, inView } = useInView({
    threshold: 1,
  });

  return (
    <Section className={styles.container}>
      <div className={styles.leftSection}>
        <Typography tag="h1" variant="heading" className={styles.title}>
          Ready-Made Videos <br /> With Your Voice & Brand
        </Typography>
        <Typography variant="body" className={styles.description}>
          We auto-post daily AI videos with your voice, face & brand{' '}
          {!isMobile && <br />}
          across all your socials.
        </Typography>
        {!isMobile && (
          <div className={styles.actionsWrapper}>
            <CtaButton />
          </div>
        )}
      </div>
      <div className={styles.rightSection}>
        <div className={styles.videoWrapper}>
          <SimpleVideoPlayer
            src="https://dofimomuk6s4.cloudfront.net/files/VuSocial-video.mp4"
            autoPlay
            muted
            loop
            // playsInline
            // disablePictureInPicture
            // disableContextMenu
            preload="metadata"
            // onContextMenu={(e) => e.preventDefault()}
          />
        </div>
        {isMobile && (
          <div ref={ref} className={styles.actionsWrapper}>
            <CtaButton fullWidth />
          </div>
        )}

        {isMobile && (
          <div
            className={clsx(styles.fixedActions, {
              [styles.visible]: !inView,
            })}
          >
            <CtaButton fullWidth />
          </div>
        )}
      </div>
    </Section>
  );
}
